import { AbstractApi, IApiData } from './AbstractApi';
import { OverlayToaster, Toaster } from "@blueprintjs/core";
export type { IApiData } from './AbstractApi';


/**
 * AbstractClientApi
 */
export class AbstractClientApi<D extends IApiData = IApiData> extends AbstractApi<D> {

    // Toaster
    protected __toaster: Toaster;

    /**
     * Toaster
     */
    public get toaster() {
        return this.__toaster;
    }

    /**
     * Create toaster
     */
    protected async createToaster() {
        if (!this.__toaster) {
            this.__toaster = await OverlayToaster.createAsync({
                canEscapeKeyClear: true,
                maxToasts: 5,
                position: 'top',
                usePortal: true
            });
        }
    }    
}